import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Popover } from '@material-ui/core';
import { makeStyles, alpha } from '@material-ui/core/styles';
import { Box } from '@material-ui/core'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  return {
    root: {},
    paper: {
      marginTop: 12,
      marginLeft: 4,
      overflow: 'inherit',
      boxShadow: theme.shadows[25].z20,
      border: "solid 1px ".concat(theme.palette.grey[5008])
    },
    arrow: _defineProperty({}, theme.breakpoints.up('sm'), {
      top: -7,
      zIndex: 1,
      width: 12,
      right: 20,
      height: 12,
      content: "''",
      position: 'absolute',
      borderRadius: '0 0 4px 0',
      transform: 'rotate(-135deg)',
      background: theme.palette.background.paper,
      borderRight: "solid 1px ".concat(alpha(theme.palette.grey[500], 0.12)),
      borderBottom: "solid 1px ".concat(alpha(theme.palette.grey[500], 0.12))
    })
  };
});
export var PopoverMenu = function PopoverMenu(_a) {
  var children = _a.children,
      width = _a.width,
      className = _a.className,
      other = __rest(_a, ["children", "width", "className"]);

  var classes = useStyles();
  return React.createElement(Popover, Object.assign({
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    className: className,
    classes: {
      root: classes.root,
      paper: classes.paper
    }
  }, other), React.createElement("span", {
    className: classes.arrow
  }), React.createElement(Box, {
    sx: {
      width: width,
      maxWidth: '100%'
    }
  }, children));
};